import { render, staticRenderFns } from "./HandleQuery.vue?vue&type=template&id=1567bbf2&scoped=true&"
import script from "./HandleQuery.vue?vue&type=script&lang=js&"
export * from "./HandleQuery.vue?vue&type=script&lang=js&"
import style0 from "./HandleQuery.vue?vue&type=style&index=0&id=1567bbf2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1567bbf2",
  null
  
)

export default component.exports